import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Coach from "@/pages/Coach";
import Accounts from "@/pages/Accounts";
import Transactions from "@/pages/Transactions";
import Goals from "@/pages/Goals";
import Insights from "@/pages/Insights";
import Settings from "@/pages/Settings";
import DebtSimulator from "@/pages/DebtSimulator";
import Referrals from "@/pages/Referrals";
import Challenges from "@/pages/Challenges";
import Recap from "@/pages/Recap";
import Budgets from "@/pages/Budgets";
import Family from "@/pages/Family";
import FamilyView from "@/pages/FamilyView";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AppShell from "@/components/AppShell";
import "@/index.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[color:var(--text-secondary)]">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/coach" element={<Protected><Coach /></Protected>} />
      <Route path="/accounts" element={<Protected><Accounts /></Protected>} />
      <Route path="/transactions" element={<Protected><Transactions /></Protected>} />
      <Route path="/goals" element={<Protected><Goals /></Protected>} />
      <Route path="/insights" element={<Protected><Insights /></Protected>} />
      <Route path="/debt-simulator" element={<Protected><DebtSimulator /></Protected>} />
      <Route path="/referrals" element={<Protected><Referrals /></Protected>} />
      <Route path="/challenges" element={<Protected><Challenges /></Protected>} />
      <Route path="/recap" element={<Protected><Recap /></Protected>} />
      <Route path="/budgets" element={<Protected><Budgets /></Protected>} />
      <Route path="/family" element={<Protected><Family /></Protected>} />
      <Route path="/family/view/:userId" element={<Protected><FamilyView /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="grain min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <Router />
          <Toaster position="top-right" theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
